import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Link} from "react-router";
import FrontImage from "../../images/front-image.png";
import Spinner from "../../images/spinner.png";
import ChevronDown from "../../images/chevron-down.png";
import bagBadge from "../../images/badges/bag.svg";
import computerBadge from "../../images/badges/computer.svg";
import creditcardBadge from "../../images/badges/creditcard.svg";
import packageBadge from "../../images/badges/package.svg";
import percentageBadge from "../../images/badges/percentage.svg";
import tagBadge from "../../images/badges/tag.svg";
import howItWorks1 from "../../images/illustrations/Cactus_IndigoFair-04.png";
import howItWorks2 from "../../images/illustrations/Cactus_IndigoFair-05.png";
import howItWorks3 from "../../images/illustrations/Cactus_IndigoFair-06.png";
import winksfStore from "../../images/stores/WinkSF.jpg";
import officehoursStore from "../../images/stores/OfficeHours.jpg";
import Logo from "../../images/logo.png";
import Values from "./Values";
import Footer from "./Footer";
import BusinessSearchComponent from "../../components/BusinessSearchComponent";
import Button from "../../components/Button";
import Api, { Utils } from "../../Api";

import {
  JUST_FOR_YOU_CATEGORY
} from '../../consts';

let values = [
  {
    className: '',
    header: 'Unique Products',
    imageUrl: bagBadge,
    description: 'Browse exciting products from hundreds of makers, all in one place.'
  },
  {
    className: '',
    header: 'Easy Ordering',
    imageUrl: computerBadge,
    description: 'Place wholesale orders with just a few clicks. Track shipments online.'
  },
  {
    className: '',
    header: 'Low Minimums',
    imageUrl: creditcardBadge,
    description: 'Opening order minimums are $150 or lower for most makers.'
  },
  {
    className: '',
    header: 'Flexible Terms',
    imageUrl: percentageBadge,
    description: 'Pay with a credit card or take Net 90 payment terms, however you like to pay.'
  },
  {
    className: '',
    header: 'Free for Retailers',
    imageUrl: tagBadge,
    description: 'Indigo Fair is completely free for retailers. No markups or fees.'
  },
  {
    className: '',
    header: 'Guaranteed Sales',
    imageUrl: packageBadge,
    description: 'Send back any products that don’t sell within 90 days with free return shipping.'
  }
];

let testimonials = [
  {
    className: '',
    imageUrl: winksfStore,
    message: 'We love working with Indigo Fair! Indigo Fair gives us the opportunity to experience new merchandise in our store and see if it is a good match for our customers. We are able to try new merchandise we might not have purchased. For example, PyroPet Candles have been one of our bestsellers and we would not have ordered them without the option to return them.',
    who: 'Marcy Isreal',
    where: 'WINK SF, San Francisco, CA'
  },
  {
    className: '',
    imageUrl: officehoursStore,
    message: 'Finding new and great products is part of the fun of owning a small store. It is also my most time-consuming activity. Indigo Fair does the leg work and researches the products to show me things I will like. Best of all, I only pay for what I sell, which allows me to carry new merchandise in the store without any risk.',
    who: 'Patricia Rudd',
    where: 'Office Hours, Mill Valley, CA'
  }
];

export default class Home extends Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    Utils.bindThis(
      this,
      [
        'handleBusinessSelected',
        'businessSelected',
        'handleAddressFocus',
        'handleSearchChange',
        'handleQueryChanged',
        'handleRawRetailer',
        'getSearchComponent',
        'shakeIt',
        'onScroll',
        'loadInitialProducts'
      ]
    );

    this.state = {
      hasSearchTerm: false,
      businessData: null,
      loading: false,
      queryString: '',
      shake: false,
      retailer: null,
      scrollTop: 0
    };
  }

  componentWillMount() {
    let retailerToken = this.props.location.query.retailer_token;
    if (retailerToken) {
      this.onSelectedRetailerToken(retailerToken);
      return;
    }

    Api.getLastSelectedRetailer()
      .then((retailerToken) => {
        if (retailerToken) {
          this.context.router.push(`/retailer/${retailerToken}`);
        }
      });

    document.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    this.setState({
      scrollTop: document.documentElement.scrollTop || document.body.scrollTop
    });
  }

  onSelectedRetailerToken(retailerToken) {
    Api.getRetailer(retailerToken, true)
      .then((retailer) => {
        this.setState({retailer});
      })
      .catch(
        (error) => {
          if (error.httpStatusCode === 401) {
            let user = Api.cache.getUser();
            if (user && user.retailer_token && user.retailer_token !== retailerToken) {
              // Send the user to the Retailer they actually own.
              this.context.router.push(`/retailer/${user.retailer_token}`);
              this.loadRetailer(user.retailer_token);
            } else {
              this.context.router.push('/');
            }
          } else {
            // TODO(sergio): We need to handle this case and display some error.
            console.log(error);
            this.setState({error: error});
          }
        }
      );
  }

  loadInitialProducts() {
    let request = Api.createProductBrowseNewPayload(JUST_FOR_YOU_CATEGORY, null, null);

    return Api.productBrowseNew(request, true);
  }

  handleBusinessSelected(businessData) {
    this.setState({businessData: businessData});
    this.businessSelected(businessData);
  }

  handleQueryChanged(query) {
    this.setState({queryString: query});
  }

  shakeIt(idx) {
    let elementList = document.getElementsByTagName('input');
    if (!elementList) return;
    let element = elementList[idx || 0];
    if (!element) return;

    element.focus();
    this.setState({shake: true});

    setTimeout(
      () => {
        if (this.state.shake) this.setState({shake: false});
      },
      1000
    );
  }

  createRetailer(payload, welcomeBack) {
    let retailerData = null;
    let isEmployee = Api.cache.getUser() && Api.cache.getUser().is_employee;

    return Api.createRetailer(payload)
      .then(retailer => {
        retailerData = retailer;

        if (retailer.invited || isEmployee) return this.loadInitialProducts();
        return retailer;
      })
      .then(() => {
        this.context.router.push(`/retailer/${retailerData.token}`);
      })
      .catch((errorData) => {
        if (errorData.httpStatusCode === 401) {
          let retailerToken = errorData.response && errorData.response.entity_token
            ? errorData.response.entity_token
            : null;
          let url = `/user`;
          if (retailerToken) {
            url += `?redirect=/retailer/${retailerToken}`;
          }
          if (welcomeBack) {
            url += '&welcomeback=1';
          }
          this.context.router.push(url);
        } else {
          this.setState({error: errorData});
        }
      });
  }

  handleRawRetailer(inputIdx) {
    let retailerToken = Api.cache.getCampaignRetailerToken();
    if (retailerToken) {
      // Display loading icon
      this.setState({
        loading: true
      });

      let url = `/retailer/${retailerToken}?campaign=1`;
      let isEmployee = Api.cache.getUser() && Api.cache.getUser().is_employee;

      return Api.getRetailer(retailerToken, true)
        .then(retailer => {
          if (retailer.invited || isEmployee) return this.loadInitialProducts();
          return retailer;
        })
        .then(() => {
          this.context.router.push(url);
        });
    }

    let businessName = this.state.queryString;
    if (businessName.length <= 5) {
      this.shakeIt(inputIdx);
      return;
    }

    this.setState({
      loading: true
    });

    return this.createRetailer({name: businessName})
  }

  businessSelected(businessData) {
    let business = businessData;
    if (!business) return;

    let images = business.photos && business.photos.map((photoObj) => {
        return {url: photoObj.getUrl({'maxWidth': 1600, 'maxHeight': 1600})};
      });

    // Combine Vicinity and First Category into friendly sentence
    // Try to remove street number from vicinity.
    let description = Utils.titleCase(business.types[0])
      + ' in the '
      + (business.vicinity || '').split(' ').splice(1).join(' ')
      + ' area.';

    let data = {
      name: business.name,
      description: description,
      url: business.website,
      display_phone_number: business.formatted_phone_number,
      display_address: business.formatted_address,
      images: images || [],
      categories: business.types,
      google_places_json: JSON.stringify(businessData)
    };

    this.setState({
      loading: true
    });

    return this.createRetailer(data, true);
  }

  handleAddressFocus() {
    //Utils.scrollTo('get-started');
  }

  handleSearchChange(searchTerm) {
    this.setState({hasSearchTerm: !!searchTerm});
    if (!searchTerm) {
      this.setState({businessData: null});
    }
  }

  getTestimonials() {
    let items = testimonials.map((testimonial, idx) =>
      <div key={`testimonial-entry-item-${idx}`}
           className={'entry' + (testimonial.className ? ' ' + testimonial.className : '')}>
        <div className="image-wrapper"><img src={testimonial.imageUrl} role="presentation"/></div>
        <p>“{testimonial.message}”</p>
        <p className="author">- <strong>{testimonial.who}</strong>, {testimonial.where}</p>
        <Button>View Store</Button>
      </div>
    );

    return (
      <div className="testimonials home-section">
        <h3>Testimonials</h3>
        <div className="wrapper">
          {items}
        </div>
      </div>
    );
  }

  getSearchComponent(refName, autofocus) {
    return <BusinessSearchComponent
      type="text"
      autofocus={!!autofocus}
      ref={refName}
      id={refName}
      onFocus={this.handleAddressFocus}
      onSearchChange={this.handleSearchChange}
      onBusinessSelected={this.handleBusinessSelected}
      onQueryChanged={this.handleQueryChanged}
    />;
  }

  render() {
    let buttonClasses = [];
    buttonClasses.push('view-products');
    if (this.state.shake) buttonClasses.push('shake');

    let buttonText = 'View Products';
    let retailerToken = Api.cache.getCampaignRetailerToken();

    if (retailerToken) {
      buttonText = 'Request Access';
    }

    return (
      <div className="landing" id="landing">
        <div className={'more-below' + (this.state.scrollTop > 50 ? ' hidden' : '')}>
          <div className="updown">
            <img src={ChevronDown} role="presentation"/>
          </div>
        </div>
        <div className="header-wrapper">
          <div className="content">
            <h2 className="logo"><img src={Logo} role="presentation"/></h2>
            <div className="headline">
              <span className="unique-finds">Unique Finds.</span>
              <span className="guaranteed-sales">Guaranteed Sales.</span>
            </div>
            <div className="businesssearch-wrapper">
              <div className={'input-wrapper' + (this.state.loading ? ' hidden' : '')}>
                {!retailerToken ? this.getSearchComponent('businessSearchInput', true) : null}
                <Button className={buttonClasses.join(' ')} onClick={() => {
                  this.handleRawRetailer(0);
                } }>{buttonText}</Button>
              </div>
              <div className={'spin' + (this.state.loading ? '' : ' hidden') }>
                <img role="presentation" src={Spinner}/>
              </div>
            </div>
          </div>
        </div>
        <div className="front-image"><img src={FrontImage} role="presentation"/></div>
        <Values headline="Buying for Your Store Just Became a Lot More Fun" values={values}/>
        {this.getTestimonials()}
        <div className="how-it-works home-section">
          <h3>How It Works</h3>
          <div className="section-header">Make every item in your store a bestseller</div>
          <div className="entry entry-1">
            <div className="image-wrapper"><img src={howItWorks2} role="presentation"/></div>
            <h4>Order products for your store.</h4>
            <p>Find items you like, add them to your bag, create an account and check out.</p>
          </div>
          <div className="entry entry-2">
            <div className="image-wrapper"><img src={howItWorks3} role="presentation"/></div>
            <h4>See which items sell best.</h4>
            <p>Items typically ship to your store from vendors within 48 hours of your order.</p>
          </div>
          <div className="entry entry-3">
            <div className="image-wrapper"><img src={howItWorks1} role="presentation"/></div>
            <h4>Return whatever doesn’t sell.</h4>
            <p>Get a free return shipping label to send back items that didn’t sell after 90
              days.</p>
          </div>
        </div>
        <div className="make-something home-section">
          <h3>Ready to try out Indigo Fair?</h3>
          <div className="businesssearch-wrapper">
            <div className={'input-wrapper' + (this.state.loading ? ' hidden' : '')}>
              {!retailerToken ? this.getSearchComponent('businessSearchInput2') : null}
              <Button className={buttonClasses.join(' ')} onClick={() => {
                this.handleRawRetailer(1);
              } }>{buttonText}</Button>
            </div>
            <div className={'spin' + (this.state.loading ? '' : ' hidden') }>
              <img role="presentation" src={Spinner}/>
            </div>
          </div>
        </div>
        <Footer>
          Make something amazing? <em><Link to="/apply">Apply to sell it on Indigo Fair.</Link></em>
        </Footer>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/Home/Home.js
 **/